import React from "react";
import { Button, Col, Row, Table } from "reactstrap";
import useSnackbar from "../../../../../../../hooks/useSnackbar";
import SnackbarNotification from "../../../../../../../toolkit/snackbarNotification";
import { DnsRecordRow, getHostNameForClipboard } from "../../utils/formatDnsRecords";
import s from "../../dnsConfigurationStep/styles.scss";
import withStyles from "isomorphic-style-loader/withStyles";

interface DnsManualRecordsTableProps {
  records: DnsRecordRow[];
  fullWidth?: boolean;
  domain?: string;
}

const DnsManualRecordsTable: React.FC<DnsManualRecordsTableProps> = ({
  records,
  fullWidth = false,
  domain,
}) => {
  const { snackbarProps, showSnackbar } = useSnackbar();

  const handleCopy = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      showSnackbar("Copied to clipboard!", "success");
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  const handleCopyHostName = (hostName: string) => {
    handleCopy(getHostNameForClipboard(hostName, domain));
  };

  const table = (
    <Table borderless className={`mb-0 ${s.manualTable}`}>
      <thead>
        <tr>
          <th className={`${s.tableHeader} ${fullWidth ? s.typeColumn : ""}`}>RECORD TYPE</th>
          <th className={s.tableHeader}>HOST NAME</th>
          <th className={s.tableHeader}>VALUE</th>
        </tr>
      </thead>
      <tbody className={s.manualBody}>
        {records.map((r, i) => (
          <tr key={i}>
            <td>
              <div
                className={`d-flex align-items-center justify-content-between w-100 ${s.firstTableCell}`}
              >
                {r.recordType}
              </div>
            </td>
            <td>
              <div className={`d-flex align-items-center justify-content-between w-100 ${s.tableCell}`}>
                <span className={`me-2 ${s.cellText}`}>{r.hostName}</span>
                <Button
                  size="sm"
                  color="primary"
                  className={s.copyButton}
                  onClick={() => handleCopyHostName(r.hostName)}
                >
                  Copy
                </Button>
              </div>
            </td>
            <td>
              <div className={`d-flex align-items-center justify-content-between w-100 ${s.tableCell}`}>
                <span className={`me-2 ${s.cellText}`}>{r.requiredValue}</span>
                <Button
                  size="sm"
                  color="primary"
                  className={s.copyButton}
                  onClick={() => handleCopy(r.requiredValue)}
                >
                  Copy
                </Button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );

  const content = fullWidth ? <div className={s.tableWrap}>{table}</div> : table;

  return (
    <>
      {fullWidth ? (
        content
      ) : (
        <Row className="justify-content-center">
          <Col md="9" className="p-2">
            {content}
          </Col>
        </Row>
      )}
      <SnackbarNotification {...snackbarProps} duration={1000} />
    </>
  );
};

export default withStyles(s)(DnsManualRecordsTable);
